<style>
  .cart-icon-content {
    display: block;
    height: 20px;
  }

</style>

<button
  data-testid="retailer-header__cart-button"
  class="fizz-cart-button"
  data-grid-area="cart"
  on:click
>
  <span class="cart-icon-content"> 0 </span>
</button>
